module.exports = __webpack_public_path__ + "img/smartfarm-firstpage-logo-2022.ff183804.png";